import {
    AnalyticsRequest,
    Metric,
    GroupBy,
    Sort,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';

export const HyperSpacePieChart: Widget = {
    type: 'hyperSpacePieChart',
    id: 'hyper-space-pie-chart',
    name: 'Pie Chart',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        new AnalyticsRequest({
            limit: 6,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicName },
                    INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_ACCOUNT_ID' },
                    PAID: { dimensionName: 'accountIds' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'RDB_DATA_SOURCE' },
                    UNIVERSAL_PROFILE: { dimensionName: 'SN_TYPE' },
                    SPR_TASK: { dimensionName: 'ASSIGNEE_ID' },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Pie Chart',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        legend: {
            enabled: true,
            position: {
                auto: true,
                selectedPosition: 'right',
            },
        },
        innerRadius: {
            enabled: false,
            size: null,
        },
        donutWidth: {
            enabled: false,
            size: null,
        },
        dataLabelOptions: {
            enabled: false,
            formats: {
                numberFormat: {
                    decimals: 2,
                    useShortened: true,
                },
            },
            fontSize: 20,
        },
        metricGroupOptions: {
            enabled: true,
            metric: {
                size: 50,
                enabled: true,
                format: {
                    decimals: 2,
                    useShortened: true,
                },
            },
            metricName: {
                size: 25,
                enabled: true,
            },
            percentChange: {
                size: 20,
                enabled: false,
            },
        },
    },
};
